// extracted by mini-css-extract-plugin
export default {"container":"_3bmVd","header":"_1wHu0","content":"_2LWsj","controls":"_3N9B3","isLayoutTextOnImage":"_20j-E"};